import { render } from "./CorporatePlanDelete.vue?vue&type=template&id=17066c06"
import script from "./CorporatePlanDelete.vue?vue&type=script&lang=js"
export * from "./CorporatePlanDelete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__